module.exports = __webpack_public_path__ + "static/media/mental-threats.2360b1ee.png";